import { createStore } from 'vuex'

export default createStore({
  state: {
    currentIndex: 0,
    name: '',
    options: [
      {
        label: 'Name & Anrede',
        multiple: false,
        bg: '#981a67',
        items: [
          {
            name: 'Per Sie',
            wert: 's1_sie'
          },
          {
            name: 'Per Du',
            wert: 's1_du'
          }
        ]
      },
      {
        label: 'Form',
        multiple: false,
        bg: '#B7C6CE',
        items: [
          {
            name: 'Kreis',
            wert: 's2_kreis',
            class: 'kreis'
          },
          {
            name: 'Viereck',
            wert: 's2_viereck',
            class: 'viereck'
          },
          {
            name: 'Dreieck',
            wert: 's2_dreieck',
            class: 'dreieck'
          }
        ]
      },
      {
        label: 'Hobbies & Interessen',
        multiple: true,
        bg: '#43A39C',
        items: [
          {
            name: 'Sushi',
            wert: 's3_sushi',
            class: 'button'
          },
          {
            name: 'Musik',
            wert: 's3_musik',
            class: 'button'
          },
          {
            name: 'Sport',
            wert: 's3_sport',
            class: 'button'
          },
          {
            name: 'Genuss',
            wert: 's3_genuss',
            class: 'button'
          },
          {
            name: 'Reisen',
            wert: 's3_reisen',
            class: 'button'
          },
          {
            name: 'Party',
            wert: 's3_party',
            class: 'button'
          },
          {
            name: 'Heimat',
            wert: 's3_heimat',
            class: 'button'
          },
          {
            name: 'Kochen',
            wert: 's3_kochen',
            class: 'button'
          },
          {
            name: 'Fußball',
            wert: 's3_fussball',
            class: 'button'
          },
          {
            name: 'Wandern',
            wert: 's3_wandern',
            class: 'button'
          },
          {
            name: 'Lagerfeuer',
            wert: 's3_lagerfeuer',
            class: 'button'
          },
          {
            name: 'Spieleabend',
            wert: 's3_spieleabend',
            class: 'button'
          },
          {
            name: 'Onthebeach',
            wert: 's3_onthebeach',
            class: 'button'
          }            
        ]
      },
      {
        label: 'Gefühl',
        multiple: false,
        bg: '#333366',
        items: [
          {
            name: 'Gemeinschaft',
            wert: 's4_gemeinschaft',
            class: 'image'
          },
          {
            name: 'Abenteuer',
            wert: 's4_abenteuer',
            class: 'image'
          },
          {
            name: 'Luxus',
            wert: 's4_luxus',
            class: 'image'
          }
        ]
      },
      {
        label: 'Anlass',
        multiple: true,
        bg: '#B41E3E',
        items: [
          {
            name: 'Festlich',
            wert: 's5_festlich',
            class: 'button'
          },
          {
            name: 'Fröhlich',
            wert: 's5_froehlich',
            class: 'button'
          },
          {
            name: 'Locker',
            wert: 's5_locker',
            class: 'button'
          },
          {
            name: 'Gediegen',
            wert: 's5_gediegen',
            class: 'button'
          },
          {
            name: 'Offiziell',
            wert: 's5_offiziell',
            class: 'button'
          },
          {
            name: 'Geschäftlich',
            wert: 's5_geschaeftlich',
            class: 'button'
          },
          {
            name: 'Verliebt',
            wert: 's5_verliebt',
            class: 'button'
          },
          {
            name: 'Verheiratet',
            wert: 's5_verheiratet',
            class: 'button'
          },
          {
            name: 'Besonders',
            wert: 's5_besonders',
            class: 'button'
          },
          {
            name: 'Natürlich',
            wert: 's5_natuerlich',
            class: 'button'
          },
          {
            name: 'Spontan',
            wert: 's5_spontan',
            class: 'button'
          }
        ]
      },
      {
        label: 'Unsere Empfehlung',
        multiple: true,
        bg: '#EDC740'
      }
    ],
    selectedOptions: [],
    showNext: false
  },
  getters: {
  },
  mutations: {
    setName(state,payload) {
      state.name = payload.name
    },
    setShowNext(state,payload) {
      state.showNext = payload.showNext
    },
    setSelectedOptions(state,payload) {
      state.selectedOptions = payload.selectedOptions
    },
    setCurrentIndex(state,payload) {
      state.currentIndex = payload.currentIndex
    }
  },
  actions: {
  },
  modules: {
  }
})
